/**
 * Markdown — assistant 文本渲染。和 desktop 同库 streamdown（流式 markdown：
 * parseIncompleteMarkdown 让 token 级 delta 半句也能正确渲染）。
 *
 * 桌面有一套很重的 ChatMarkdown（mermaid / shiki 插件 / 自定义 components）；
 * 手机这版刻意轻 —— 只要把 markdown 排版好，移动端 UX 自己调。
 */

import { Streamdown } from 'streamdown'
import 'streamdown/styles.css'

export default function Markdown({ content }: { content: string }) {
  return (
    <div className="cortex-md text-sm leading-relaxed text-secondary [&_pre]:my-2 [&_pre]:overflow-x-auto [&_code]:text-[12px] [&_a]:text-accent-light [&_a]:underline">
      <Streamdown parseIncompleteMarkdown>{content}</Streamdown>
    </div>
  )
}
